// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The connecting screen reuses the Home shell (.home) and header (.home__brand
   / .home__logo). We only add: the logo fly-in, and the loading body. */

/* Bring the logo in as a deliberate entrance rather than trying to match the
   native splash's logo position (which is a full-screen scaleAspectFill image,
   so the bird lands in a device-dependent spot we can't reliably match). We
   fade + rise + settle from a slightly-below, slightly-smaller state into the
   exact Home-header resting slot. We animate ONLY transform and opacity, which
   are GPU-composited, so the mascot never re-rasterizes mid-flight. The resting
   state is the header's own \`transform: scaleX(-1)\`; the keyframe ends at
   exactly that, so the hand-off to Home is pixel-identical.

   The animation is gated behind \`.connecting.is-ready\`, which the component
   only adds once the mascot PNG is decoded (and, on native, as it hides the
   splash). Until then the logo is hidden, so the entrance can never play
   against a blank or half-loaded image. */
.connecting__logo {
  opacity: 0;
  will-change: transform;
}
.connecting.is-ready .connecting__logo {
  opacity: 1;
  animation: connectLogoEnter 760ms cubic-bezier(0.34, 0.01, 0.22, 1) 220ms both;
}

@keyframes connectLogoEnter {
  from {
    opacity: 0;
    /* Start below and a touch smaller so the bird reads as arriving into its
       slot. \`scaleX(-1)\` keeps it facing into the screen throughout. */
    transform: translateY(34px) scale(0.86) scaleX(-1);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1) scaleX(-1);
  }
}

/* Fade the rest of the header in just after the logo lands, so the screen
   reads as the app assembling itself around the mascot. Hidden until ready so
   the whole sequence starts together with the logo fly-in. */
.connecting .home__brand-text {
  opacity: 0;
}
.connecting.is-ready .home__brand-text {
  animation: connectFade 420ms ease-out 780ms both;
}

/* Loading body fills the space under the header and centers the indicator. */
.connecting__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 0 32px;
}

.connecting__dots {
  display: flex;
  gap: 8px;
  opacity: 0;
}
.connecting.is-ready .connecting__dots {
  animation: connectFade 400ms ease-out 900ms both;
}
.connecting__dots i {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--palette-border-strong);
  opacity: 0.25;
  animation: connectDot 1.2s infinite;
}
.connecting__dots i:nth-child(2) {
  animation-delay: 0.18s;
}
.connecting__dots i:nth-child(3) {
  animation-delay: 0.36s;
}

.connecting__caption {
  font-family: var(--font-display);
  font-style: italic;
  color: var(--palette-text-muted);
  font-size: 1rem;
  opacity: 0;
}
.connecting.is-ready .connecting__caption {
  animation: connectFade 400ms ease-out 1040ms both;
}

@keyframes connectDot {
  0%,
  80%,
  100% {
    opacity: 0.22;
  }
  40% {
    opacity: 1;
    background: var(--palette-primary);
  }
}

@keyframes connectFade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Reduced motion: no fly-in or fades. The header renders in place and the
   loading indicator shows immediately once the logo is ready. The selectors are
   scoped to \`.is-ready\` so they still outrank the animated \`.connecting.is-ready\`
   rules above (equal specificity, later in source), keeping motion off. */
@media (prefers-reduced-motion: reduce) {
  .connecting__logo,
  .connecting .home__brand-text,
  .connecting__caption,
  .connecting__dots,
  .connecting.is-ready .connecting__logo,
  .connecting.is-ready .home__brand-text,
  .connecting.is-ready .connecting__caption,
  .connecting.is-ready .connecting__dots {
    animation: none;
    opacity: 1;
  }
  .connecting__dots i {
    animation: none;
    opacity: 0.4;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/connectingScreen.css"],"names":[],"mappings":"AAAA;wEACwE;;AAExE;;;;;;;;;;;;0CAY0C;AAC1C;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,8EAA8E;AAChF;;AAEA;EACE;IACE,UAAU;IACV;uEACmE;IACnE,kDAAkD;EACpD;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;6DAE6D;AAC7D;EACE,UAAU;AACZ;AACA;EACE,gDAAgD;AAClD;;AAEA,6EAA6E;AAC7E;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gDAAgD;AAClD;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mCAAmC;AACrC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,UAAU;AACZ;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE;;;IAGE,aAAa;EACf;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;0EAG0E;AAC1E;EACE;;;;;;;;IAQE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* The connecting screen reuses the Home shell (.home) and header (.home__brand\n   / .home__logo). We only add: the logo fly-in, and the loading body. */\n\n/* Bring the logo in as a deliberate entrance rather than trying to match the\n   native splash's logo position (which is a full-screen scaleAspectFill image,\n   so the bird lands in a device-dependent spot we can't reliably match). We\n   fade + rise + settle from a slightly-below, slightly-smaller state into the\n   exact Home-header resting slot. We animate ONLY transform and opacity, which\n   are GPU-composited, so the mascot never re-rasterizes mid-flight. The resting\n   state is the header's own `transform: scaleX(-1)`; the keyframe ends at\n   exactly that, so the hand-off to Home is pixel-identical.\n\n   The animation is gated behind `.connecting.is-ready`, which the component\n   only adds once the mascot PNG is decoded (and, on native, as it hides the\n   splash). Until then the logo is hidden, so the entrance can never play\n   against a blank or half-loaded image. */\n.connecting__logo {\n  opacity: 0;\n  will-change: transform;\n}\n.connecting.is-ready .connecting__logo {\n  opacity: 1;\n  animation: connectLogoEnter 760ms cubic-bezier(0.34, 0.01, 0.22, 1) 220ms both;\n}\n\n@keyframes connectLogoEnter {\n  from {\n    opacity: 0;\n    /* Start below and a touch smaller so the bird reads as arriving into its\n       slot. `scaleX(-1)` keeps it facing into the screen throughout. */\n    transform: translateY(34px) scale(0.86) scaleX(-1);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1) scaleX(-1);\n  }\n}\n\n/* Fade the rest of the header in just after the logo lands, so the screen\n   reads as the app assembling itself around the mascot. Hidden until ready so\n   the whole sequence starts together with the logo fly-in. */\n.connecting .home__brand-text {\n  opacity: 0;\n}\n.connecting.is-ready .home__brand-text {\n  animation: connectFade 420ms ease-out 780ms both;\n}\n\n/* Loading body fills the space under the header and centers the indicator. */\n.connecting__body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  padding: 0 32px;\n}\n\n.connecting__dots {\n  display: flex;\n  gap: 8px;\n  opacity: 0;\n}\n.connecting.is-ready .connecting__dots {\n  animation: connectFade 400ms ease-out 900ms both;\n}\n.connecting__dots i {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--palette-border-strong);\n  opacity: 0.25;\n  animation: connectDot 1.2s infinite;\n}\n.connecting__dots i:nth-child(2) {\n  animation-delay: 0.18s;\n}\n.connecting__dots i:nth-child(3) {\n  animation-delay: 0.36s;\n}\n\n.connecting__caption {\n  font-family: var(--font-display);\n  font-style: italic;\n  color: var(--palette-text-muted);\n  font-size: 1rem;\n  opacity: 0;\n}\n.connecting.is-ready .connecting__caption {\n  animation: connectFade 400ms ease-out 1040ms both;\n}\n\n@keyframes connectDot {\n  0%,\n  80%,\n  100% {\n    opacity: 0.22;\n  }\n  40% {\n    opacity: 1;\n    background: var(--palette-primary);\n  }\n}\n\n@keyframes connectFade {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Reduced motion: no fly-in or fades. The header renders in place and the\n   loading indicator shows immediately once the logo is ready. The selectors are\n   scoped to `.is-ready` so they still outrank the animated `.connecting.is-ready`\n   rules above (equal specificity, later in source), keeping motion off. */\n@media (prefers-reduced-motion: reduce) {\n  .connecting__logo,\n  .connecting .home__brand-text,\n  .connecting__caption,\n  .connecting__dots,\n  .connecting.is-ready .connecting__logo,\n  .connecting.is-ready .home__brand-text,\n  .connecting.is-ready .connecting__caption,\n  .connecting.is-ready .connecting__dots {\n    animation: none;\n    opacity: 1;\n  }\n  .connecting__dots i {\n    animation: none;\n    opacity: 0.4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
